import React, { useState } from 'react';
import {alertModal } from '../../../../components/modals/antd-modals';
import { useDispatch, useSelector } from 'react-redux';

const Error = () => {
    const dialog = useSelector(state => state.auth.dialog)
    return (
        <>
        {errorModal(dialog)}
        </>
    )
};

const errorModal = (dialog) =>{
    alertModal.error({
        title: `STATUS ${dialog.status.code}: ${dialog.status.message}`,
        content: (
            <div>
                <p>{`${dialog.message}`}</p>
            </div>
        ),
        onOk() {
            
        },
    });
}




export default Error;

